<div [className]="this.className">
  <!--Waves Container-->
  <div class="padding__top__16">
    <span class="display__flex height__100 position__absolute backButtonArrow" style="z-index: 51000; "
      *ngIf="showBackButton" slot="start">
      <ion-icon *ngIf="!passaFunzioneParent" [routerLink]=" '/' + this.paginaProvenienza" [name]="iconName"></ion-icon>
      <ion-icon *ngIf="passaFunzioneParent" (click)="this.parentFunction()" [name]="iconName"></ion-icon>
    </span>
    <span class="display__flex align__items__center justify__center">

      <span *ngIf="customText != ''">
        <b>{{this.customText | uppercase }} </b>
      </span>
      <span *ngIf="timer ">
        TIMEOUT: <b *ngIf="timer" id="timer"></b>
      </span>
    </span>
    <svg class="waves" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
      viewBox="0 24 150 28" preserveAspectRatio="none" shape-rendering="auto">
      <defs>
        <path id="gentle-wave" d="M-160 44c30 0 58-18 88-18s 58 18 88 18 58-18 88-18 58 18 88 18 v44h-352z" />
      </defs>
      <g class="parallax">
        <use xlink:href="#gentle-wave" x="48" y="0" fill="rgba(255,255,255,0.7" />
        <use xlink:href="#gentle-wave" x="48" y="3" fill="rgba(255,255,255,0.5)" />
        <use xlink:href="#gentle-wave" x="48" y="5" fill="rgba(255,255,255,0.3)" />
        <use xlink:href="#gentle-wave" x="48" y="7" fill="#fff" />
      </g>
    </svg>
  </div>
  <!--Waves end-->

</div>
<!--Header ends-->
